/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import jMoment from 'moment-jalaali'
import {message} from 'antd'
import {ExcelExport, grid, gridColumn, gridToolbar} from '@progress/kendo-react-excel-export'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import FromToPicker from '../BaseComponent/FromToPicker'
import SearchableCombo from '../BaseComponent/searchableCombo'
import $ from 'jquery'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import {accounting} from 'accounting'
import {Link} from 'react-router-dom'
import HeaderTable from '../BaseComponent/HeaderTable'
import Page from '../Pagination/Pagination'
import cookie from 'react-cookies'
import USER_MANAGE from '../BaseComponent/USERMANAGE'

class ActivityDrivers extends React.Component {
  getActivityReport = (
    pageNumber = sessionStorage.getItem('pageNumber'),
    pageSize = sessionStorage.getItem('dropDownVal'),
    params = sessionStorage.getItem('params')
  ) => {
    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_DRIVER_STATEHISTORY
        }?export=false&pageNumber=${pageNumber}&pageSize=${pageSize}&${params}`,
        {}
      )
      .then((response) => {
        if (response.data.error === null) {
          this.setState({
            activity: response.data.object.result,
            countAll: response.data.object.countAll,
            buttonClicked: true
          })
          $('.showBaseTable,.print').fadeIn()
        } else {
          this.setState({
            activity: [],
            countAll: 0,
            buttonClicked: false
          })
          $('.showBaseTable,.print').fadeOut()
        }
      })
  }
  componentDidMount() {
    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          var drivers = response.data.object
          for (let i = 0; i < drivers.length; i++) {
            drivers[i]['value'] = drivers[i].personId
            drivers[i]['label'] = drivers[i].personId + ' - ' + drivers[i].name
          }

          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
    sessionStorage.setItem('params', '')
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
  }

  getValueDriver = (driverId) => {
    this.setState({
      driverId
    })
  }
  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }
  handleChangeFromDateApp = (fromDateApp) => {
    this.setState({
      fromDateApp
    })
  }

  handleChangeToDateApp = (toDateApp) => {
    this.setState({
      toDateApp
    })
  }
  onResultFetched(data) {
    this.setState({
      activity: data
    })
  }

  changeDropDown(data) {
    this.setState({
      activity: data,
      countAll: this.state.countAll
    })
  }
  constructor(props) {
    super(props)
    this.state = {
      activity: [],
      printInfo: [],
      Drivers: [],
      fromDate: '',
      toDate: '',
      fromDateApp: '',
      toDateApp: '',
      buttonClicked: false,
      driverId: ''
    }
  }
  filter() {
    let serverTimeMin = this.state.fromDate
    let serverTimeMax = this.state.toDate
    let appTimeMin = this.state.fromDateApp
    let appTimeMax = this.state.toDateApp
    let state = document.getElementById('state').value
    let driverId = this.state.driverId == null || this.state.driverId == '' ? '' : this.state.driverId.personId
    if (
      appTimeMax === '' &&
      appTimeMin === '' &&
      driverId === '' &&
      state === '' &&
      serverTimeMin === '' &&
      serverTimeMax === ''
    ) {
      message.error('حداقل یک فیلتر شود.')
    } else if ((serverTimeMin != '' || serverTimeMin == null) && isNaN(serverTimeMin)) {
      message.error('فرمت تاریخ ابتدای سرور صحیح نیست')
    } else if ((serverTimeMax != '' || serverTimeMax == null) && isNaN(serverTimeMax)) {
      message.error('فرمت تاریخ انتهای سرور صحیح نیست')
    } else if ((appTimeMin != '' || appTimeMin == null) && isNaN(appTimeMin)) {
      message.error('فرمت تاریخ ابتدای اپلیکیشن صحیح نیست')
    } else if ((appTimeMax != '' || appTimeMax == null) && isNaN(appTimeMax)) {
      message.error('فرمت تاریخ انتهای اپلیکیشن صحیح نیست')
    } else {
      sessionStorage.setItem('pageNumber', '1')
      sessionStorage.setItem('dropDownVal', '10')
      sessionStorage.setItem(
        'params',
        `appTimeMax=${appTimeMax}&appTimeMin=${appTimeMin}&state=${state}&serverTimeMin=${serverTimeMin}&serverTimeMax=${serverTimeMax}&driverId=${driverId}`
      )
      this.getActivityReport()
    }
  }

  convertState = (state) => {
    if (state === -100) {
      state = 'کنسل'
    } else if (state === -10) {
      state = 'خارج از سرویس'
    } else if (state === 1) {
      state = 'فعال'
    } else if (state === 100) {
      state = 'آفلاین'
    } else {
      state = state
    }
    return state
  }

  getPrintInfo = () => {
    http
      .get(`${REPORT_RETAIL.REPORT_RETAIL_DRIVER_STATEHISTORY}?export=true&${sessionStorage.getItem('params')}`, {})
      .then((response) => {
        if (response.data.error == null) {
          sessionStorage.setItem('countAll', response.data.object.countAll)

          this.setState({
            printInfo: response.data.object.result,
            lengthRemains: response.data.object.countAll
          })

          setTimeout(() => {
            window.print()
          }, 2000)
        } else {
          this.setState({
            printInfo: []
          })
          // message.error(response.data.description)
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  exportExcel = () => {
    http
      .get(
        `${
          REPORT_RETAIL.REPORT_RETAIL_DRIVER_STATEHISTORY
        }?export=true&pageSize=10&pageNumber=1&${sessionStorage.getItem('params')}`,
        {}
      )
      .then((response) => {
        if (response.data.error == null) {
          console.log(response.data)

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state

          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['serverTime'] = jMoment(excelReport[i]['serverTime']).format('jYY/jM/jD HH:mm')
            if (excelReport[i]['appTime'] !== null) {
              excelReport[i]['appTime'] = jMoment(excelReport[i]['appTime']).format('jYY/jM/jD HH:mm')
            } else {
              excelReport[i]['appTime'] = '-'
            }
            if (excelReport[i]['offline']) {
              excelReport[i]['offline'] = 'بله'
            } else {
              excelReport[i]['offline'] = 'خیر'
            }

            excelReport[i]['state'] = this.convertState(excelReport[i]['state'])
          }
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {})
  }

  render() {
    let pageNumber = sessionStorage.getItem('pageNumber')
    let dropDownVal = sessionStorage.getItem('dropDownVal')
    let params = sessionStorage.getItem('params')
    let name = cookie.load('name')
    let printColumns = ['ردیف', 'رساننده', 'موبایل', 'تاریخ ثبت سرور', 'تاریخ ثبت اپلیکیشن', 'آنلاین', 'وضعیت']
    let excelColumns = []
    return (
      <div className="rtl printA4Page">
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش فعالیت رساننده ها"
              headerColSpan={7}
              reporter={name}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={3}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printColumns}
            />
            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.driver.name}</td>
                  <td>{item.driver.mobile}</td>
                  <td>{item.serverTime === null ? '' : jMoment(item.serverTime).format('jYY/jM/jD HH:mm')}</td>
                  <td>{item.appTime === null ? '' : jMoment(item.appTime).format('jYY/jM/jD HH:mm')}</td>
                  <td>{item.offline ? 'بله' : 'خیر'}</td>
                  <td>{this.convertState(item.state)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName={'گزارش فعالیت رساننده ها.xls'}
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'driverName'}
                field={'driver.name'}
                title={'رساننده'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'drivermobile'}
                field={'driver.mobile'}
                title={'موبایل'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'serverTime'}
                field={'serverTime'}
                title={'تاریخ ثبت سرور'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'appTime'}
                field={'appTime'}
                title={'تاریخ ثبت اپلیکیشن'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'offline'}
                field={'offline'}
                title={'آنلاین'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'state'}
                field={'state'}
                title={'وضعیت'}
                width="120"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>رساننده ها</li>
            <li>گزارش فعالیت رساننده ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable
                  addUrl=""
                  url={REPORT_RETAIL.REPORT_RETAIL_DRIVER_STATEHISTORY}
                  ChangeDropDown={this.changeDropDown.bind(this)}
                  printUrl="test"
                  printComponent={this.printTable}
                  titleAdd=""
                  execelUrl=""
                  excelColumns={excelColumns}
                  printLink=""
                />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button
                  className={'printButton'}
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportExcel}
                >
                  <i className="fas fa-file-excel" />
                </button>
                <button
                  className="printButton"
                  disabled={this.state.buttonClicked ? false : true}
                  onClick={this.exportPrint}
                >
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ ثبت سرور از"
                  toLabel="تاریخ ثبت سرور تا"
                  defaulValue={false}
                  fromId="serverTimeMin"
                  toId="serverTimeMax"
                />
                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDateApp}
                  onChangeToDate={this.handleChangeToDateApp}
                  fromLabel="تاریخ ثبت اپلیکیشن از"
                  toLabel="تاریخ  ثبت اپلیکیشن  تا"
                  defaulValue={false}
                  fromId="appTimeMin"
                  toId="appTimeMax"
                />
                <div className="formComponent">
                  <SearchableCombo
                    options={this.state.Drivers}
                    getValueCombo={this.getValueDriver}
                    lableText="رساننده"
                    placeholder="------"
                    isClearable={true}
                    isMulti={false}
                    isDisabled={false}
                    force={false}
                  />
                </div>
                <div className="formComponent">
                  <label>وضعیت</label>
                  <select className="form-control" id={'state'}>
                    <option value="">------</option>
                    <option value="-10">خارج از سرویس</option>
                    <option value="1">فعال</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>رساننده</td>
                    <td>موبایل</td>
                    <td>تاریخ ثبت سرور</td>
                    <td>تاریخ ثبت اپلیکیشن</td>
                    <td>آنلاین</td>
                    <td>وضعیت</td>
                  </tr>
                  {this.state.activity.map((item, index) => (
                    <tr key={index}>
                      <td>{(pageNumber - 1) * dropDownVal + index + 1}</td>
                      <td>{item.driver.name}</td>
                      <td>{item.driver.mobile}</td>
                      <td>{item.serverTime === null ? '' : jMoment(item.serverTime).format('jYY/jM/jD HH:mm')}</td>
                      <td>{item.appTime === null ? '' : jMoment(item.appTime).format('jYY/jM/jD HH:mm')}</td>
                      <td>{item.offline ? 'بله' : 'خیر'}</td>
                      <td>{this.convertState(item.state)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="paginationWrapp">
                <Page
                  defaultCurrent={1}
                  total={this.state.countAll}
                  onResultFetched={this.onResultFetched.bind(this)}
                  urlParams={params}
                  url={REPORT_RETAIL.REPORT_RETAIL_DRIVER_STATEHISTORY}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default ActivityDrivers
